import {
    CONFIRM_BOOKING,
    CONFIRM_BOOKING_SUCCESS,
    CONFIRM_BOOKING_FAILED,
    CLEAR_BOOKING
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { formatBookingObject } from '../other/sharedFunctions';
import { get, push } from "firebase/database";
import { errorMessage, stripUndefined } from '../other/apiClient';

export const clearBooking = () => (dispatch) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

export const addBooking = (bookingData) => async (dispatch) => {

    const   {
        bookingRef,
        settingsRef,
        singleUserRef
    } = firebase;

    dispatch({
        type: CONFIRM_BOOKING,
        payload: bookingData,
    });

    const fail = (message) => dispatch({ type: CONFIRM_BOOKING_FAILED, payload: message });
    const lang = store.getState().languagedata.defaultLanguage || {};

    if (!bookingData || !bookingData.pickup || !bookingData.pickup.coords || !bookingData.drop || !bookingData.drop.coords) {
        return fail(lang.address_missing || 'Veuillez choisir une adresse de départ et de destination.');
    }
    if (!bookingData.userDetails || !bookingData.userDetails.uid) {
        return fail(lang.not_logged_in || 'Veuillez vous connecter pour réserver.');
    }
    if (!bookingData.estimate || bookingData.estimate.estimateFare == null) {
        return fail(lang.estimate_error || 'Impossible de calculer le prix de la course. Réessayez.');
    }

    try {
        const settingsdata = await get(settingsRef);
        const settings = settingsdata.val();
        const data = stripUndefined(await formatBookingObject(bookingData, settings));
        const res = await push(bookingRef, data);
        const bookingKey = res.key;

        dispatch({
            type: CONFIRM_BOOKING_SUCCESS,
            payload: {
                booking_id: bookingKey,
                mainData: { ...data, id: bookingKey }
            }
        });

        // Notifications après l'enregistrement : un échec de push ne bloque plus la réservation.
        if (bookingData.requestedDrivers) {
            Object.keys(bookingData.requestedDrivers).forEach(async (uid) => {
                try {
                    const snapshot = await get(singleUserRef(uid));
                    const driver = snapshot.val();
                    if (driver && driver.pushToken) {
                        RequestPushMsg(driver.pushToken, {
                            title: lang.notification_title,
                            msg: lang.new_booking_notification,
                            screen: 'DriverTrips'
                        });
                    }
                } catch (e) {
                    console.warn('Driver notification failed', e);
                }
            });
        }
    } catch (error) {
        console.warn('addBooking failed', error);
        fail(errorMessage(error) || lang.booking_error || 'La réservation a échoué. Veuillez réessayer.');
    }
};
